import { useToast } from '@konova/ui/use-toast';
import { AxiosError } from 'axios';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getAxios } from '../get-axios/get-axios';

const globInstance = getAxios();

export const useAxios = () => {
  const toast = useToast();

  const [, i18n] = useTranslation();

  const axiosInstance = useMemo(
    () => {
      globInstance.defaults.headers.common['Accept-Language'] = encodeURI(i18n.language);
      return globInstance;
    },
    [i18n.language]
  );

  useEffect(() => {
    const interceptorId = axiosInstance.interceptors.response.use(
      response => response,
      (response: AxiosError<{ message?: string }>) => {
        if (
          response.status === 500
          && response.response?.data.message
          && import.meta.env.MODE === 'development'
        ) {
          toast.add(response.response.data.message, 'error');
        }

        return Promise.reject(response);
      }
    );

    return () => {
      axiosInstance.interceptors.response.eject(interceptorId);
    };
  }, []);

  return axiosInstance;
};